import React, { Component } from "react";
import classes from "./StatsCarousel.module.css";
import Slide from "./Slide/Slide";
import sustainabilityImg from "../../../assets/images/sustainability-resized.jpg";
import studyAbroadImg from "../../../assets/images/studyabroad-resized.jpg";
import volunteerImg from "../../../assets/images/volunteer-resized.jpg";

class StatsCarousel extends Component {
  state = {
    slides: [
      {
        img: sustainabilityImg,
        headline: "No. 2 in the nation for Sustainability",
        alt: "Student working on the Farm",
        description:
          'No. 2 Overall Top Performer among baccalaureate institutions in the Association for the Advancement of Sustainability in Higher Education\'s "Sustainable Campus Index"',
        active: true,
      },
      {
        img: studyAbroadImg,
        headline: "No. 5 in Long-term Study Abroad",
        alt: "Study abroad program in Japan",
        description: "Open Doors Report, Institute of International Education",
        active: false,
      },
      {
        img: volunteerImg,
        headline: "20,000 Volunteer Hours",
        alt: "Volunteering in our community",
        description:
          "Served by members of the Dickinson community (students, faculty, staff) in 2018-2019",
        active: false,
      },
    ],
    currentActive: 0,
  };

  render() {
    const nextSlideHandler = () => {
      let getCurrentActive = this.state.currentActive;
      const getSlidesLength = this.state.slides.length;

      getCurrentActive++;

      if (getCurrentActive === getSlidesLength) {
        getCurrentActive = 0;
      }

      this.setState({
        currentActive: getCurrentActive,
      });
    };

    const prevSlideHandler = () => {
      let getCurrentActive = this.state.currentActive;
      const getSlidesLength = this.state.slides.length;

      getCurrentActive--;

      if (getCurrentActive < 0) {
        getCurrentActive = getSlidesLength - 1;
      }

      this.setState({
        currentActive: getCurrentActive,
      });
    };

    const slides = this.state.slides.map((slide, index) => (
      <Slide
        active={this.state.currentActive === index ? true : false}
        img={slide.img}
        alt={slide.alt}
        headline={slide.headline}
        description={slide.description}
        key={index}
      />
    ));

    return (
      <div className={classes.StatsCarousel}>
        <div className={classes.Slides}>
          {slides}

          {/* <Slide
            active="true"
            img={sustainabilityImg}
            alt="Student working on the farm"
          />
          <Slide img={studyAbroadImg} alt="Study abroad program in Japan" />
          <Slide img={volunteerImg} alt="Volunteering in the community" /> */}
        </div>
        <div className={classes.Actions}>
          <button name="Previous" onClick={prevSlideHandler}>
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="arrow-circle-left"
              className="svg-inline--fa fa-arrow-circle-left fa-w-16"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path
                fill="currentColor"
                d="M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm28.9-143.6L209.4 288H392c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24H209.4l75.5-72.4c9.7-9.3 9.9-24.8.4-34.3l-11-10.9c-9.4-9.4-24.6-9.4-33.9 0L107.7 239c-9.4 9.4-9.4 24.6 0 33.9l132.7 132.7c9.4 9.4 24.6 9.4 33.9 0l11-10.9c9.5-9.5 9.3-25-.4-34.3z"
              ></path>
            </svg>
            <p className={classes.SrOnly}>Previous</p>
          </button>
          <button name="Next" onClick={nextSlideHandler}>
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="arrow-alt-circle-right"
              className="svg-inline--fa fa-arrow-alt-circle-right fa-w-16"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path
                fill="currentColor"
                d="M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zM140 300h116v70.9c0 10.7 13 16.1 20.5 8.5l114.3-114.9c4.7-4.7 4.7-12.2 0-16.9l-114.3-115c-7.6-7.6-20.5-2.2-20.5 8.5V212H140c-6.6 0-12 5.4-12 12v64c0 6.6 5.4 12 12 12z"
              ></path>
            </svg>
            <p className={classes.SrOnly}>Next</p>
          </button>
        </div>
      </div>
    );
  }
}

export default StatsCarousel;
